export default class Teachers {
    constructor() {
        this.teachersModal()
        this.notMeirotUser()
    }

    teachersModal() {
        const modal = document.getElementById("teachers-video-modal");
        const modalFrame = document.getElementById("teachers-modal-video-frame");
        const body = document.querySelector("body");
        const subscribe_popup = document.querySelector(".teacher-subscribe-popup");

        if(!modal) return;

        document.querySelectorAll('.video-thumbnail').forEach(image => {
            image.addEventListener('click', function () {
                let videoId = this.parentElement.getAttribute('data-video-id');
                let videoUrl = `https://www.youtube.com/embed/${videoId}`;

                body.style.overflow = "hidden";
                modal.style.display = "flex";
                modalFrame.src = videoUrl;
            });
        });

        window.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = "none";
                modalFrame.src = "";
                body.style.overflow = "";
            }
        });

        modal.querySelector('.teachers-video-modal__close-btn')?.addEventListener('click', function (event) {
            modal.style.display = "none";
            modalFrame.src = "";
            body.style.overflow = "";
        });

    }

    notMeirotUser() {
        const teacher_page = document.querySelector('.teacher-page');
        if(!teacher_page) return;

        $(document).ready(function () {
            const not_meriot_user = $('.teacher-page:not(.role-meirot)')

            if(!not_meriot_user.length) return;

            const grid = not_meriot_user.find('.jet-listing-grid,.teachers-video-repeater');

            grid.find('.jet-listing-grid__item,.teachers-video-repeater__item').each(function (){
                $(this).css('pointer-events','none')
            })

            grid.click(function () {
                $('.teacher-subscribe-popup').css('display','flex');
                // $('body').css('overflow','hidden');
            })

            $(window).click(function (event) {
                const popup = document.querySelector(".teacher-subscribe-popup")
                if(event.target === popup){
                    popup.style.display = "none";
                    $('body').css('overflow','');
                }
            })

            $('.teacher-subscribe-popup__close-btn').click(function (event) {
                const popup = document.querySelector(".teacher-subscribe-popup")
                if(popup) {
                    popup.style.display = "none";
                    $('body').css('overflow','');
                }
            })

        })

    }


}




